import { SORT_OPTIONS } from '../utils/hooks/useSort';

export enum MobileDeviceStatuses {
    active = 'active',
    blocked = 'blocked',
}

export enum ApkType {
    vendor = 'vendor',
    partner = 'partner',
}

export interface MobileDevice {
    id: number;
    imei: string;
    status: MobileDeviceStatuses;
    apkType: ApkType;
    createdAt: string;
    updatedAt: string;
    vendorName: string;
    vendorId?: string; // SAP ID
    partnerName: string;
    partnerId?: number;
    outlet?: string;
    passwordAttempts: number;
    blocked: boolean;
    lastTransactionAt?: string;
}

export const defaultMobileDeviceSortingOrder: SORT_OPTIONS = {
    'orderBy:column': 'createdAt',
    'orderBy:direction': 'DESC',
};
